"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledBadge = exports.StyledAvatarGroup = void 0;
var _ykbStyledComponents = _interopRequireDefault(require("../ykb-styled-components"));
var StyledAvatar = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-8vnr7f-0"
})(["&.", "{position:relative;display:inline-block;color:", ";white-space:nowrap;text-align:center;vertical-align:middle;cursor:default;background:", ";font-weight:", ";border-radius:", ";&-square{border-radius:", ";}&-image-img{display:block;}width:", "px;height:", "px;line-height:", "px;font-size:", ";&-xs{width:", "px;height:", "px;line-height:", "px;font-size:", ";}&-sm{width:", "px;height:", "px;line-height:", "px;font-size:", ";}&-lg{width:", "px;height:", "px;line-height:", "px;font-size:", ";}&-xl{width:", "px;height:", "px;line-height:", "px;font-size:", ";}&-xxl{width:", "px;height:", "px;line-height:", "px;font-size:", ";}& > img{display:block;width:100%;height:100%;object-fit:cover;border-radius:50%;}> .", "-string{position:absolute;left:50%;transform-origin:0 center;}margin-left:", ";&:nth-child(16n + 1){margin-left:", ";}&:nth-child(n + 17){margin-top:", ";}}"], function (props) {
  return props.$prefixCls;
}, function (props) {
  return props.theme.avatar.color;
}, function (props) {
  return props.theme.avatar.backgroundColor;
}, function (props) {
  return props.theme.avatar.fontWeight;
}, function (props) {
  return props.theme.avatar.circleBorderRadius;
}, function (props) {
  return props.theme.avatar.squareBorderRadius;
}, function (props) {
  return props.theme.avatar.size.default;
}, function (props) {
  return props.theme.avatar.size.default;
}, function (props) {
  return props.inGroup ? props.theme.avatar.size.default - 4 : props.theme.avatar.size.default;
}, function (props) {
  return props.theme.avatar.fontSize.default;
}, function (props) {
  return props.theme.avatar.size.xsmall;
}, function (props) {
  return props.theme.avatar.size.xsmall;
}, function (props) {
  return props.inGroup ? props.theme.avatar.size.xsmall - 4 : props.theme.avatar.size.xsmall;
}, function (props) {
  return props.theme.avatar.fontSize.xsmall;
}, function (props) {
  return props.theme.avatar.size.small;
}, function (props) {
  return props.theme.avatar.size.small;
}, function (props) {
  return props.inGroup ? props.theme.avatar.size.small - 4 : props.theme.avatar.size.small;
}, function (props) {
  return props.theme.avatar.fontSize.small;
}, function (props) {
  return props.theme.avatar.size.large;
}, function (props) {
  return props.theme.avatar.size.large;
}, function (props) {
  return props.inGroup ? props.theme.avatar.size.large - 4 : props.theme.avatar.size.large;
}, function (props) {
  return props.theme.avatar.fontSize.large;
}, function (props) {
  return props.theme.avatar.size.xlarge;
}, function (props) {
  return props.theme.avatar.size.xlarge;
}, function (props) {
  return props.inGroup ? props.theme.avatar.size.xlarge - 4 : props.theme.avatar.size.xlarge;
}, function (props) {
  return props.theme.avatar.fontSize.xlarge;
}, function (props) {
  return props.theme.avatar.size.xxlarge;
}, function (props) {
  return props.theme.avatar.size.xxlarge;
}, function (props) {
  return props.inGroup ? props.theme.avatar.size.xxlarge - 4 : props.theme.avatar.size.xxlarge;
}, function (props) {
  return props.theme.avatar.fontSize.xxlarge;
}, function (props) {
  return props.$prefixCls;
}, function (props) {
  return props.inPopover && '5px';
}, function (props) {
  return props.inPopover && '0';
}, function (props) {
  return props.inPopover && '10px';
});
var StyledAvatarGroup = exports.StyledAvatarGroup = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-8vnr7f-1"
})(["&.", "{display:inline-flex;> span{border:", ";&:not(:first-child){margin-left:", ";}}}"], function (props) {
  return props.className;
}, function (props) {
  return props.theme.avatar.group.border;
}, function (props) {
  return props.theme.avatar.group.overlapping;
});
var StyledBadge = exports.StyledBadge = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-8vnr7f-2"
})(["position:absolute;right:", "px;top:", "px;background-color:#f24739;color:white;font-size:10px;border-radius:8px;line-height:normal;min-width:", ";height:", ";padding:", ";"], function (props) {
  return props.position;
}, function (props) {
  return props.position;
}, function (props) {
  return props.$noNumber ? '8px' : '16px';
}, function (props) {
  return props.$noNumber ? '8px' : '17px';
}, function (props) {
  return !props.$noNumber && '1px 5px';
});
var _default = exports.default = StyledAvatar;